import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_attched_pointeuses_member",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  key: 0,
  class: "modal-dialog modal-lg"
}
const _hoisted_3 = { class: "modal-content position-relative" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "varyingModalLabel"
}, " Donner l’accès à la pointeuse ", -1)
const _hoisted_6 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_9 = { class: "col-md-6 text-right" }
const _hoisted_10 = { class: "col-md-6 text-right" }
const _hoisted_11 = {
  type: "submit",
  class: "w-100 btn btn-primary mr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_MultipSelect = _resolveComponent("MultipSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.requestAttachDetachMember)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.isRequestMember)
              ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('modal_attched_pointeuses_member', 'edit'))),
                type: "button",
                class: "btn-close",
                "aria-label": "btn-close"
              })
            ]),
            (_ctx.requestAttachDetachMember)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("form", {
                    class: "forms-sample",
                    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      (_ctx.hasPermission('affected_pointeuses_to_member'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createVNode(_component_MultipSelect, {
                              TextLabel: _ctx.i18n.t('tables.subscription_member.access'),
                              trackby: `id`,
                              label: `name`,
                              valueProp: `id`,
                              modelValue: _ctx.requestAttachDetachMember.devices,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestAttachDetachMember.devices) = $event)),
                              placeholder: _ctx.i18n.t('tables.subscription_member.access'),
                              arrayOptions: _ctx.pointeusesList,
                              refs: "pointeuses",
                              v: _ctx.v$.pointeuses
                            }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeModal('modal_attched_pointeuses_member', 'edit'))),
                          class: "w-100 btn btn-cancel"
                        }, _toDisplayString(_ctx.i18n.t("button.close")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("button", _hoisted_11, _toDisplayString(_ctx.i18n.t("button.edit")), 1)
                      ])
                    ])
                  ], 32)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}